/*
    This file has been generated by LoTS app. All rights reserved.
  Do not edit this file directly, the file can potentially be overridden by the app. Instead, use the LoTS app to make changes.
  If you want to edit the code, then please duplicate the file and make changes to the duplicated file.
  ---
  version:1.0.0
*/

if (typeof LotsStickyFW !== 'function') {
  class LotsStickyFW extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.blocks = [];

      this.querySelectorAll('.lots-sticky-block').forEach((el) => {
        this.blocks.push(el);
      });

      this.slideRaf = true;

      this.onScrollHandler = (() => {
        if (this.slideRaf) {
          this.slideRaf = false;
          requestAnimationFrame(this.slideAnimation.bind(this));
        }
      }).bind(this);

      window.addEventListener('scroll', this.onScrollHandler, {
        passive: true,
      });
      window.addEventListener('resize', this.onScrollHandler, {
        passive: true,
      });
      this.onScrollHandler();
    }

    slideAnimation() {
      // Calculate the vertical offset of the parent element relative to the top of the viewport, including the scroll position
      const mainOffset =
        this.parentElement.getBoundingClientRect().y + window.scrollY;

      // Get the current scroll position from the top of the page
      const scrollTop = window.scrollY;

      // Get the height of the first block element
      const blockHeight = this.blocks[0].offsetHeight;

      // Iterate over each block element
      this.blocks.forEach((block, i) => {
        // Calculate the position of the current block relative to the viewport
        const blockY =
          scrollTop -
          mainOffset +
          (window.innerHeight - blockHeight) -
          blockHeight * i;

        // Check if the block is within the viewport vertically
        if (
          block.getBoundingClientRect().y < window.innerHeight &&
          block.getBoundingClientRect().y > -window.innerHeight
        ) {
          if (scrollTop <= mainOffset) {
            // If the scroll position is at or above the parent element's offset
            // Apply scale(1) transformation if the block is the first or if the block is fully visible
            if (
              i === 0 ||
              block.getBoundingClientRect().y + block.offsetHeight <=
                window.innerHeight
            ) {
              block.style.transform = 'scale(1)';
            } else if (!this.zoom) {
              block.style.transform = '';
            }
          } else if (blockY > 0 && i !== this.blocks.length - 1) {
            // Apply scale and opacity transformations based on block's position
            // const scale =
            //   1 - (blockY * 100) / blockHeight / (this.blocks.length * 2);

            // Simplified calculation for scale
            const scale = 1 - blockY / blockHeight / (this.blocks.length * 4);
            block.style.transform = `scale(${scale})`;

            // Simplified calculation for opacity
            const opacity = 1 - blockY / blockHeight / this.blocks.length;
            block.style.opacity = opacity;
          }
        }
      });

      // Flag that the sliding animation frame has been set
      this.slideRaf = true;
    }
  }

  if (typeof customElements.get('lots-sticky-fw') == 'undefined') {
    customElements.define('lots-sticky-fw', LotsStickyFW);
  }
}